"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextShaper = void 0;
var createTextShaper = function (_a) {
    var fontData = _a.fontData, harfBuzz = _a.harfBuzz;
    var blob = harfBuzz.createBlob(new Uint8Array(fontData.bytes));
    var face = harfBuzz.createFace(blob, 0);
    var font = harfBuzz.createFont(face);
    var glyphs = {};
    var getGlyph = function (glyphId) {
        var cached = glyphs[glyphId];
        if (cached) {
            return cached;
        }
        var glyph = font.glyphToJson(glyphId);
        glyphs[glyphId] = glyph;
        return glyph;
    };
    var withShapeResult = function (text, fn) {
        var buffer = harfBuzz.createBuffer();
        buffer.addText(text);
        buffer.guessSegmentProperties();
        harfBuzz.shape(font, buffer);
        var result = fn(buffer.json(font));
        buffer.destroy();
        return result;
    };
    return {
        shape: function (_a) {
            var text = _a.text, fontSize = _a.fontSize;
            var ax = 0;
            var ay = 0;
            var path = '';
            withShapeResult(text, function (result) {
                result.forEach(function (x) {
                    var glyph = getGlyph(x.g);
                    glyph.forEach(function (command) {
                        if (command.type === 'Z') {
                            return;
                        }
                        var values = command.values.map(function (p, i) {
                            return String(i % 2 ? -(p + ay + x.dy) : p + ax + x.dx);
                        });
                        path += "".concat(command.type).concat(values.join(' '));
                    });
                    ax += x.ax;
                    ay += x.ay;
                });
            });
            var scale = fontSize / fontData.fontMetrics.unitsPerEm;
            return { path: path, scale: scale };
        },
        measure: function (_a) {
            var text = _a.text, fontSize = _a.fontSize;
            var ax = 0;
            var ay = 0;
            withShapeResult(text, function (result) {
                result.forEach(function (x) {
                    ax += x.ax;
                    ay += x.ay;
                });
            });
            var scale = fontSize / fontData.fontMetrics.unitsPerEm;
            var width = ax * scale;
            var height = ay * scale;
            return { width: width, height: height };
        },
        destroy: function () {
            font.destroy();
            face.destroy();
            blob.destroy();
        },
    };
};
exports.createTextShaper = createTextShaper;
